<ng-container>
  {{ formattedDate }}
</ng-container>
